// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".body__overflowPrevented {\n  touch-action: none;\n  overflow: hidden;\n}", ""]);
// Exports
module.exports = exports;
